import {Culture} from "../i18n/Culture";

export function currentCulture(): Culture {
	return Culture.getCurrent();
}
